module.exports = __webpack_public_path__ + "img/ASDA-logo.1b7988a7.png";